export default {
  list_menu: {
    registrations: 'Experimente nosso plano Basic!',
    login: 'Acessar conta',
    alt_img: 'Logomarca Represente Soluções em TI',
  },
  benefits: {
    title: 'Alguns dos recursos oferecidos',
    call: 'represente, o seu sistema de gestão de clientes!',
    description: 'Gestão de clientes de maneira fácil, rápida e prática.',
    description_complement: 'A ferramenta que vai dar mais agilidade ao seu time de vendas, além de estreitar ainda mais a relação de seu negócio com quem importa: seus clientes.',
    title_clients: 'Clientes',
    clients: 'Centralize em um só lugar as informações básicas e o histórico de relacionamento com seus clientes',
    title_schedule: 'Agendamentos',
    schedule: 'Avisamos quais os clientes foram agendados para realizar contato no dia e quais, por ventura, estão com contatos atrasados',
    title_access_level: 'Níveis de acesso',
    access_level: 'Cada usuário poderá acessar funções e ações que realmente são adequadas para o seu perfil, otimizando assim o trabalho',
    title_online: 'Online',
    online: 'Tenha acesso às informações de qualquer lugar e em qualquer dispositivo, necessitando apenas do acesso a internet',
    title_products_order: 'Produtos e Orçamentos',
    products_order: 'Em breve estará disponível o módulo para gestão de produtos, estoques, orçamentos e pedidos',
  },
  security: {
    title: 'Seus dados disponívels em qualquer lugar, de forma segura e confiável',
    title_security: 'Segurança',
    description_security: 'Nossos servidores realizam backups automaticamente, os deixando armazenados de forma segura',
    title_confidence: 'Confiabilidade',
    description_confidence: 'Nossa plataforma tem alto índice de confiabilidade, disponível 97,4% do período, as manutenções são programadas e avisadas com antecedência',
    title_privacity: 'Privacidade',
    description_privacity: 'Pode ficar tranquilo, suas informações ficam disponíveis apenas para os membros do seu time, sem risco de exposição de dados à  terceiros',
  },
  registrations: {
    title: 'Experimente nosso plano Basic!',
  },
  customers: {
    title: 'O que dizem nossos clientes',
    description_diatech: 'Já utilizamos o sistema de gestão de clientes há algum tempo aqui na empresa, e tem melhorado muito a produtividade da equipe de vendas e o vínculo com nossos clientes.',
    description_mural: 'O que mais gosto neste sistema é a possibilidade de acessar os dados de qualquer lugar, seja no escritório ou até mesmo em visita ao cliente! É muito fácil poder acompanhar o trabalho da equipe.',
    description_rafaela: 'É um sistema de fácil utilização, que agiliza muito a rotina de contato com nossos clientes. O recurso de agendamento funciona muito bem para que os nossos clientes não fiquem sem receber nosso contato.',
  },
  pricing: {
    title: 'Planos e preços',
    plan: 'Plano',
    unity_month: '/mês',
    unity: '/usuário',
    coin: 'R$',
    register: 'Registrar',
    unlimited: 'Ilimitados',
    user: 'usuário',
    register_clients: 'registros de clientes',
    unpublish: 'Sem exibição de publicidade',
    publish: 'Exibição de publicidade',
    support: 'Suporte',
    online: 'online',
    per_mail: 'por e-mail',
    up_to: 'Até',
    only: 'Apenas',
  },
  footer: {
    text_business: 'represente é um software de gestão de clientes, que auxilia na gestão de agendamentos, na interação e no bom relacionamento com os clientes de sua empresa.',
    keywords: 'Gestão de clientes, gestão empresarial, soluções em internet, sistemas online, ERP, SAAS',
    mail: 'E-mail',
    copyright: 'Copyright',
    text_complement: 'Todos os direitos reservados à',
    represente: 'Represente Soluções Internet',
  },
};
